import { doc, getDoc, getDocFromServer } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';
import User from '../models/User';

/**
 * Load the signed-in user's profile from Firestore, preferring the server
 * so lifecycle fields (e.g. accountStatus) are not stale after sign-out.
 */
export async function fetchUserProfileSnapshot(uid) {
  const docRef = doc(db, 'users', uid);
  try {
    return await getDocFromServer(docRef);
  } catch {
    return getDoc(docRef);
  }
}

export async function fetchUserProfile(uid) {
  const docSnap = await fetchUserProfileSnapshot(uid);
  if (!docSnap.exists()) {
    return null;
  }
  return User.fromFirestore(docSnap);
}
